import Swiper from "swiper";
import {A11y, Autoplay} from 'swiper/modules';
import {slideUp} from "../../../../default/global/js/utilities/slide";
import {getOptionsFromJsonString} from "../../../../default/global/js/utilities/options";
import {setCookie} from "../../../../default/global/js/utilities/cookie";

function generateCloseBtn() {
    let btnCloseBar = document.createElement("a");
    let btnCloseBarIcon = document.createElement("i");

    btnCloseBar.classList.add("trustBar__close");
    btnCloseBar.href="#";
    btnCloseBar.title=GLOBALS.tc.close;
    btnCloseBarIcon.classList.add("icon");
    btnCloseBarIcon.classList.add("icon-close");
    btnCloseBarIcon.setAttribute('aria-hidden', 'true');
    btnCloseBar.appendChild(btnCloseBarIcon);

    return btnCloseBar;
}

function buildTrustbarSlider(bar) {

    bar.classList.add("swiper");

    let swiperWrapper = document.createElement("div");
    swiperWrapper.classList.add("swiper-wrapper");
    for (let content of bar.querySelectorAll('.textcontent')) {
        content.classList.add("swiper-slide");
        swiperWrapper.appendChild(content);
    }
    bar.appendChild(swiperWrapper);
}

function startTrustbarSlider(bar, options = {}) {

    let childrenCount = bar.querySelectorAll('.swiper-wrapper > *').length;

    let breakpoints = {
        xs: {
            items: 1,
            autoplay: childrenCount > 1
        },
        sm: {
            items: 2,
            autoplay: childrenCount > 2
        },
        md: {
            items: 3,
            autoplay: childrenCount > 3
        }
    };

    if (options.items < 2) {
        breakpoints.sm.items = options.items;
        if (options.items < childrenCount) {
            breakpoints.sm.autoplay = true;
        }
    }

    if (options.items < 3) {
        breakpoints.md.items = options.items;
        if (options.items < childrenCount) {
            breakpoints.md.autoplay = true;
        }
    }
    Swiper.use([Autoplay,A11y]);
    let swiperElement = new Swiper(bar, {
        loop: true,
        speed: options.eff_interval,
        allowTouchMove: false,
        a11y: {
            slideRole: null,
            slideLabelMessage: null
        },
        spaceBetween: options.spaceBetween,
        freeMode: true,
        breakpoints: {
            0: {
                slidesPerView: breakpoints.xs.items,
                autoplay: {
                    enabled: breakpoints.xs.autoplay,
                    disableOnInteraction: true,
                }
            },
            768: {
                slidesPerView: breakpoints.sm.items,
                autoplay: {
                    enabled: breakpoints.sm.autoplay,
                    disableOnInteraction: true,

                }
            },
            1024: {
                slidesPerView: breakpoints.md.items,
                autoplay: {
                    enabled: breakpoints.md.autoplay,
                    disableOnInteraction: true,

                }
            }
        },
        autoplay: {
            delay: options.autoplay_interval,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        }
    });
}

export function initTrustbars(query = document.querySelectorAll('.js-trustBar')) {
    for (let bar of query) {

        let options = getOptionsFromJsonString(bar.getAttribute('data-options'), {
            autoplay_interval: 5000,
            eff_interval: 300,
            spaceBetween: 20,
            items: 1,
            hasCloseBtn: false,
            position: "top"
        });


        buildTrustbarSlider(bar);
        startTrustbarSlider(bar, options);

        if (options.hasCloseBtn) {
            let btnCloseBar = generateCloseBtn();
            bar.appendChild(btnCloseBar);

            btnCloseBar.addEventListener("click", function (e) {
                e.preventDefault();
                slideUp(bar, 200, "linear", function () {
                    setCookie('trustBarHidden', true, 7);
                });
            });
        }
        if(options.position==="bottom"){
            hideTrustbarWhenFooterInView(bar);
        }

    }
}
function hideTrustbarWhenFooterInView(trustBar) {
    const footer = document.querySelector('.footer');
    if (!footer || !trustBar) return;

    trustBar.style.transition = 'transform 0.2s ease-in-out, opacity 0.2s ease-in-out';
    trustBar.style.transform = 'translateY(0)';
    trustBar.style.opacity = '1';

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                trustBar.style.transform = 'translateY(100%)';
                trustBar.style.opacity = '0';
            } else {
                trustBar.style.transform = 'translateY(0)';
                trustBar.style.opacity = '1';
            }
        });
    }, { threshold: 0.1 });

    observer.observe(footer);
}